var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
var buildStyles = makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    errorCard: {
        width: "40%",
        border: "1px solid " + theme.palette.error.dark,
        borderRadius: 5,
        // borderColor: theme.palette.error.main,
        background: theme.palette.common.white,
    },
    errorContent: {
        background: theme.palette.error.light + "33", //`
    },
    errorHeader: {
        backgroundColor: theme.palette.error.light + "55",
        borderBottomColor: theme.palette.error.main,
        color: theme.palette.error.dark,
        padding: theme.spacing(1) + "px " + theme.spacing(0) + "px", //`
    },
    errorBody: {
        padding: theme.spacing(2),
    },
    title: {
        fontSize: "1.2rem",
    },
    errorText: {
        textAlign: "center",
        fontSize: "0.9rem",
        fontWeight: 300,
    },
    details: {
        backgroundColor: theme.palette.error.light + "11",
        width: "100%",
    }
}); });
var ErrorCard = function (_a) {
    var message = _a.message, details = _a.details, hideHeader = _a.hideHeader;
    var classes = buildStyles();
    return (_jsx(Grid, __assign({ id: "error-view", container: true, justifyContent: "center", className: classes.root }, { children: _jsx(Grid, __assign({ container: true, className: classes.errorCard }, { children: _jsxs(Grid, __assign({ container: true, className: classes.errorContent }, { children: [!hideHeader && (_jsx(Grid, __assign({ container: true, justifyContent: "center", className: classes.errorHeader }, { children: _jsx(Typography, __assign({ className: classes.title }, { children: "Error" }), void 0) }), void 0)), _jsx(Grid, __assign({ container: true, justifyContent: "center", className: classes.errorBody }, { children: _jsx(Typography, __assign({ className: classes.errorText }, { children: message }), void 0) }), void 0), details &&
                        _jsx(Grid, __assign({ container: true, className: classes.errorBody }, { children: _jsxs(Accordion, __assign({ variant: "outlined", className: classes.details }, { children: [_jsx(AccordionSummary, { children: _jsx(Typography, __assign({ className: classes.errorText }, { children: "Details" }), void 0) }, void 0), _jsx(AccordionDetails, { children: _jsx(Typography, __assign({ className: classes.errorText }, { children: details }), void 0) }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default ErrorCard;
